import { trackChatWithFeedbackEvents } from '@modules/chatWithFeedback/utils';
import { useIsChatWithFeedbackEnabled } from '@modules/feed/hooks';
import {
  AssistanceResponseNoButton,
  AssistanceResponseThumbDownButtonProps,
} from '@modules/oracle/components/AssistanceResponseNoButton/AssistanceResponseNoButton';
import { FeedbackSummaryActionType } from '@modules/oracle/feedbackSummaryStore/feedbackSummaryActionType';
import { useFeedbackSummaryStore } from '@modules/oracle/feedbackSummaryStore/feedbackSummaryStore';
import { useFlagFeedbackSummary } from '@modules/oracle/hooks';

interface FeedbackListSummaryThumbsDownButtonProps {
  responseID?: string;
  isFeedbackSidebarView?: boolean;
  viewToken: string | undefined;
}

export function FeedbackListSummaryNoButton({
  responseID,
  isFeedbackSidebarView,
  viewToken,
}: FeedbackListSummaryThumbsDownButtonProps) {
  const dislikeSet = useFeedbackSummaryStore(({ visual }) => visual.dislikeSet);
  const dispatch = useFeedbackSummaryStore(({ dispatch }) => dispatch);
  const sessionID = useFeedbackSummaryStore(({ data }) => data.sessionID);
  const [flagFeedbackSummary] = useFlagFeedbackSummary();

  const isChatWithFeedbackEnabled = useIsChatWithFeedbackEnabled();

  if (!responseID) {
    return null;
  }

  const isResponseNo = dislikeSet.has(responseID);

  const onFeedbackSubmit: AssistanceResponseThumbDownButtonProps['onFeedbackSubmit'] =
    async (comments: string, selectedOptions: string[]) => {
      await flagFeedbackSummary({
        responseID,
        comments,
        reasons: selectedOptions,
        isResponseGood: false,
        viewToken,
        sessionID: sessionID ?? undefined,
      });

      dispatch({
        type: FeedbackSummaryActionType.SET_VISUAL,
        payload: {
          dislikeSet: new Set([...dislikeSet, responseID]),
        },
      });
    };

  return (
    <AssistanceResponseNoButton
      responseID={responseID}
      onFeedbackSubmit={onFeedbackSubmit}
      disabled={isResponseNo}
      sx={{
        color: isChatWithFeedbackEnabled ? 'primary.main' : 'text.secondary',
      }}
      userFeedbackOptions={[
        'Summary took a long time to load.',
        'I am not happy with the quality of the summary.',
      ]}
      size="small"
      onClick={() => {
        trackChatWithFeedbackEvents({
          eventName: 'Chat With Feedback - Thumbs Down Button Clicked',
          route: window.location.pathname,
          isFeedbackSidebarView,
        });
      }}
    />
  );
}
